module.exports = __webpack_public_path__ + "media/images/gift_card-415cf738927df029f52886b69dd665cf.svg";